/* ============================================================
   GOOTER Quiz Modal - Logic (bilingual via data attributes)
   Trigger: [data-quiz-open], <a href="#gooter-quiz">
   Close: [data-quiz-close], ESC, Backdrop
   ============================================================ */
(function () {
  'use strict';

  var modal = document.getElementById('gooter-quiz');
  if (!modal) return;

  var contentEl = document.getElementById('gquizContent');
  var lastFocus = null;
  var answers = [];
  var current = 0;

  var I18N = {
    resultLabel: modal.dataset.i18nResultLabel || 'Dein Match',
    ctaProduct: modal.dataset.i18nCtaProduct || 'Modell ansehen',
    ctaCompare: modal.dataset.i18nCtaCompare || 'Alle vergleichen',
    restart: modal.dataset.i18nRestart || 'Quiz neu starten'
  };

  /* Locale-aware fallback: prefix with /xx if pathname starts with /xx/ */
  var _qBase = '';
  try {
    var _qPn = (window.location && window.location.pathname) || '';
    var _qM = _qPn.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(\/|$)/i);
    if (_qM && _qM[1].slice(0,2).toLowerCase() !== 'de') _qBase = '/' + _qM[1].toLowerCase();
  } catch(_e){}
  var COMPARE_URL = modal.dataset.compareUrl || (_qBase + '/pages/elektro-golftrolley-vergleich');

  function getSteps() { return modal.querySelectorAll('.gquiz__step'); }
  function getDots() { return modal.querySelectorAll('.gquiz__dot'); }

  function open() {
    lastFocus = document.activeElement;
    answers = [];
    current = 0;
    resetQuiz();
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var first = modal.querySelector('.gquiz__option');
      if (first) first.focus();
    }, 100);
  }

  function close() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function resetQuiz() {
    if (!modal.__initialHTML) {
      modal.__initialHTML = contentEl.innerHTML;
    } else {
      contentEl.innerHTML = modal.__initialHTML;
    }
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function showResult(rec) {
    contentEl.innerHTML = '<div class="gquiz__result">' +
      '<p class="gquiz__result-label">' + escapeHtml(I18N.resultLabel) + '</p>' +
      '<h3 class="gquiz__result-name">' + escapeHtml(rec.name) + '</h3>' +
      '<p class="gquiz__result-why">' + escapeHtml(rec.why) + '</p>' +
      '<div class="gquiz__result-actions">' +
        '<a class="gquiz__result-cta" href="' + escapeHtml(rec.url) + '">' + escapeHtml(I18N.ctaProduct) + '</a>' +
        '<a class="gquiz__result-cta gquiz__result-cta--secondary" href="' + escapeHtml(COMPARE_URL) + '">' + escapeHtml(I18N.ctaCompare) + '</a>' +
      '</div>' +
      '<button type="button" class="gquiz__restart" data-quiz-restart>' + escapeHtml(I18N.restart) + '</button>' +
      '</div>';
  }

  function rec(prefix) {
    var d = modal.dataset;
    return {
      name: d[prefix + 'Name'] || '',
      why: d[prefix + 'Why'] || '',
      url: d[prefix + 'Url'] || '#'
    };
  }

  function recommend(a) {
    var has = function (t) { return a.indexOf(t) !== -1; };
    if (has('ride')) return rec('recRide');
    if (has('sit')) return rec('recSit');
    if (has('follow')) {
      if (has('long')) return rec('recFollowLong');
      return rec('recFollow');
    }
    if (has('walk')) {
      if (has('light')) return rec('recWalkLight');
      return rec('recWalk');
    }
    return rec('recDefault');
  }

  /* --- Event delegation on modal content --- */
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-quiz-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (e.target.closest('[data-quiz-restart]')) {
      e.preventDefault();
      answers = [];
      current = 0;
      resetQuiz();
      return;
    }
    var opt = e.target.closest('.gquiz__option');
    if (!opt) return;
    e.preventDefault();
    answers.push(opt.getAttribute('data-tags'));
    current++;
    var steps = getSteps();
    var dots = getDots();
    if (current >= steps.length) {
      showResult(recommend(answers));
      return;
    }
    steps[current - 1].classList.remove('is-active');
    steps[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
    var firstOpt = steps[current].querySelector('.gquiz__option');
    if (firstOpt) firstOpt.focus();
  });

  /* --- Global triggers --- */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-quiz-open], a[href="#gooter-quiz"]');
    if (trig) {
      e.preventDefault();
      open();
    }
  });

  /* --- ESC to close --- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      close();
    }
  });
})();
